import { ArrowButton } from 'components';
import React from 'react';

export const ExpiredJob: React.FC = () => {
    return (
        <ArrowButton
            style={{
                padding: '18px 20px',
                fontSize: '20px',
                backgroundColor: 'rgba(0,0,0,.3)',
            }}
            text="Expired"
            disabled
            hasIcon={false}
            disableRipple={false}
        />
    );
};
